// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid[data-v-22bf2aaa] {\n  height: 100%;\n  overflow: auto;\n}\n.grid .row[data-v-22bf2aaa] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n.grid .activated[data-v-22bf2aaa] {\n  background-color: aqua;\n}\n", ""]);
// Exports
module.exports = exports;
